<ng-template vdrDialogTitle>{{ title | translate }}</ng-template>

<customer-filter-table></customer-filter-table>



<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button
    type="submit"
    (click)="select()"
    [disabled]="customerTable.selected.length === 0"
    class="btn btn-primary"
  >
    {{ "common.okay" | translate }}
  </button>
</ng-template>
